import { useRef, useEffect } from "react";

export const useOnOutsideClick = (handleOutsideClick) => {
  const innerBorderRef = useRef(null);

  const onClick = (event) => {
    if (
      innerBorderRef.current &&
      !innerBorderRef.current.contains(event.target)
    ) {
      handleOutsideClick();
    }
  };

  useMountEffect(() => {
    document.addEventListener("touchstart", onClick, true);
    document.addEventListener("click", onClick, true);
    return () => {
      document.removeEventListener("touchstart", onClick, true);
      document.removeEventListener("click", onClick, true);
    };
  });

  return { innerBorderRef };
};

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = (fun) => useEffect(fun, []);
